export default "__VITE_ASSET__C8pc9zf9__"